export interface Category {
  name: string;
  icon: string;
  desc: string;
  count: string;
}

export interface HotItem {
  title: string;
  channel: string;
  heat: string;
  time: string;
  brief: string;
}

export interface Article {
  channel: string;
  tag: string;
  title: string;
  excerpt: string;
  reads: string;
  comments: string;
  time: string;
  author: string;
  image: string;
}

export interface Feature {
  eyebrow: string;
  title: string;
  excerpt: string;
  readTime: string;
  author: string;
  date: string;
  image: string;
}

export interface Plan {
  name: string;
  badge: string;
  tagline: string;
  points: string[];
}

export interface Testimonial {
  name: string;
  tag: string;
  text: string;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const brandName = "今日瓜报";
export const brandSlogan = "把今天的瓜，都给你攒齐了";
export const contactEmail = "hello@jinriguabao.example";

export const navLinks = [
  { id: "channels", label: "频道栏目" },
  { id: "hot", label: "今日热瓜" },
  { id: "briefing", label: "瓜报头条" },
  { id: "feature", label: "深度专题" },
  { id: "plans", label: "订阅方案" },
  { id: "about", label: "关于口碑" },
];

export const categories: Category[] = [
  { name: "内娱速递", icon: "ri-flashlight-line", desc: "剧集综艺、艺人动态第一手内幕与解读", count: "每周 90+ 条" },
  { name: "影视综艺", icon: "ri-film-line", desc: "热播剧与王牌综艺的看点、口碑与后台花絮", count: "每周 80+ 条" },
  { name: "乐坛风向", icon: "ri-disc-line", desc: "新歌打榜、演唱会与乐坛大事记", count: "每周 40+ 条" },
  { name: "海外热点", icon: "ri-earth-line", desc: "国际娱乐圈与全球流行文化动向", count: "每周 60+ 条" },
  { name: "体坛花絮", icon: "ri-trophy-line", desc: "赛场之外的球星故事与体坛热搜", count: "每周 35+ 条" },
  { name: "时尚生活", icon: "ri-shirt-line", desc: "红毯造型、潮流单品与生活方式观察", count: "每周 50+ 条" },
];

export const hotList: HotItem[] = [
  { title: "顶流机场同框神秘友人，全网都在猜是谁", channel: "内娱速递", heat: "326万", time: "18 分钟前", brief: "同框视频被反复放大，评论区秒变推理现场。" },
  { title: "某爆款综艺收官夜，观众缘口碑两极分化", channel: "影视综艺", heat: "251万", time: "1 小时前", brief: "导演组深夜发文回应争议，节目组回应冲上热搜。" },
  { title: "新剧路透流出，男女主对手戏火花十足", channel: "影视综艺", heat: "198万", time: "2 小时前", brief: "片方暂未回应，但粉丝已开始二创狂欢。" },
  { title: "乐坛新专上线，乐评人口碑褒贬不一", channel: "乐坛风向", heat: "164万", time: "3 小时前", brief: "主打单曲空降榜单，数字专辑销量走势受关注。" },
  { title: "体坛名将泪别赛场，告别瞬间刷屏", channel: "体坛花絮", heat: "142万", time: "4 小时前", brief: "多年征战一朝告别，无数球迷留言致敬。" },
  { title: "红毯造型盘点出炉，谁是你心中的最佳", channel: "时尚生活", heat: "118万", time: "5 小时前", brief: "造型团队连夜认领，网友投票激烈进行中。" },
];

export const headlines: Article[] = [
  {
    channel: "内娱速递",
    tag: "首发",
    title: "独家拆解：从路透到定档，这部古装剧凭什么未播先火",
    excerpt: "选角官宣才三天，话题阅读量就破十亿。我们扒了扒它背后的排播节奏、物料节奏与观众缘密码。",
    reads: "12.6万阅读",
    comments: "834",
    time: "今日 09:20",
    author: "切瓜小队",
    image: "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20a%20chinese%20period%20costume%20drama%20behind%20the%20scenes%2C%20film%20clapperboard%20and%20camera%2C%20warm%20coral%20and%20cream%20palette%2C%20soft%20linen%20texture%2C%20flat%20stylized%20vector%20art%2C%20minimal%20clean%20composition&width=900&height=620&seq=gua-head-01&orientation=landscape",
  },
  {
    channel: "乐坛风向",
    tag: "热评",
    title: "唱作人新专辑细听指南：十首歌里的时代情绪",
    excerpt: "从第一句副歌开始，这张专辑就不打算讨好任何人。乐评人说：这才是今年值得单曲循环的答案。",
    reads: "9.8万阅读",
    comments: "562",
    time: "今日 08:45",
    author: "音浪观察员",
    image: "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20vinyl%20record%20and%20music%20notes%20floating%2C%20vintage%20warm%20tones%2C%20coral%20and%20sand%20palette%2C%20soft%20linen%20paper%20texture%2C%20flat%20stylized%20vector%20art%2C%20minimal%20composition&width=900&height=620&seq=gua-head-02&orientation=landscape",
  },
  {
    channel: "海外热点",
    tag: "现场",
    title: "海外音乐节现场直击：三万人一起把高潮唱成了雨夜",
    excerpt: "我们隔着时差替你看了这场被刷屏的演出，从设备到安可，把值得抄的作业都记下了。",
    reads: "7.3万阅读",
    comments: "410",
    time: "昨日 22:10",
    author: "海外蹲瓜员",
    image: "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20outdoor%20music%20festival%20crowd%20at%20night%20with%20stage%20lights%2C%20confetti%2C%20warm%20and%20leaf%20green%20palette%2C%20soft%20paper%20texture%2C%20flat%20stylized%20vector%20art%2C%20minimal%20composition&width=900&height=620&seq=gua-head-03&orientation=landscape",
  },
  {
    channel: "影视综艺",
    tag: "揭秘",
    title: "爆款综艺的后期有多能打？一份切片背后的工作量",
    excerpt: "你以为只是花字和配乐，其实一集的剪辑脚本能写满三张 A4。综艺「网感」是这么炼成的。",
    reads: "6.1万阅读",
    comments: "288",
    time: "昨日 20:30",
    author: "观察室小编",
    image: "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20tv%20studio%20editing%20timeline%20and%20clapperboard%2C%20screens%20and%20headphones%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20soft%20linen%20texture%2C%20flat%20stylized%20vector%20art&width=900&height=620&seq=gua-head-04&orientation=landscape",
  },
  {
    channel: "体坛花絮",
    tag: "致敬",
    title: "告别战之后的十二小时：名将「最后一跑」刷屏全纪录",
    excerpt: "从赛前热泪到赛后挥手，我们还原了那场被载入记忆的比赛是如何被全网共同记住的。",
    reads: "5.4万阅读",
    comments: "197",
    time: "昨日 18:05",
    author: "赛场连线",
    image: "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20athlete%20crossing%20finish%20line%20with%20confetti%20and%20crowd%2C%20warm%20coral%20and%20leaf%20green%20palette%2C%20soft%20paper%20texture%2C%20flat%20stylized%20vector%20art%2C%20minimal%20composition&width=900&height=620&seq=gua-head-05&orientation=landscape",
  },
  {
    channel: "时尚生活",
    tag: "盘点",
    title: "今季红毯最佳造型，设计师们私藏的 5 套答卷",
    excerpt: "有品牌造型师向我们透露：真正的高级感，往往藏在不起眼的配饰与剪裁细节里。",
    reads: "4.7万阅读",
    comments: "163",
    time: "昨日 16:40",
    author: "衣橱侦察兵",
    image: "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20of%20red%20carpet%20evening%20gown%20and%20jewelry%20detail%2C%20elegant%20warm%20tones%2C%20coral%20and%20cream%20palette%2C%20soft%20linen%20texture%2C%20flat%20stylized%20vector%20art%2C%20minimal%20composition&width=900&height=620&seq=gua-head-06&orientation=landscape",
  },
];

export const features: Feature[] = [
  {
    eyebrow: "深度观察 · 行业篇",
    title: "选秀十年，偶像生态是如何悄悄变天的",
    excerpt: "从全民投票到垂直赛道，从舞台竞演到内容长尾。十年间偶像产业完成了一场自我重构，我们用一期长文把它讲透。",
    readTime: "12 分钟",
    author: "编辑部深度组",
    date: "本期专题 · 周五更新",
    image: "https://readdy.ai/api/search-image?query=Editorial%20longform%20feature%20illustration%20of%20stage%20spotlight%20and%20rising%20idol%20silhouette%20over%20ten%20years%20timeline%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20soft%20linen%20paper%20texture%2C%20flat%20stylized%20vector%20art%2C%20premium%20composition&width=1200&height=680&seq=gua-feat-01&orientation=landscape",
  },
  {
    eyebrow: "吃瓜方法论 · 教你看门道",
    title: "从一张路透照，看出剧到底火没火",
    excerpt: "流量、路透、词条、二创……吃瓜老手教你用五个维度判断一部剧的「真火」还是「假热」。",
    readTime: "8 分钟",
    author: "编辑部瓜学组",
    date: "周四加更",
    image: "https://readdy.ai/api/search-image?query=Editorial%20longform%20feature%20illustration%20of%20magnifying%20glass%20over%20newspaper%20clippings%20and%20trending%20tags%2C%20warm%20coral%20and%20leaf%20green%20palette%2C%20soft%20linen%20texture%2C%20flat%20stylized%20vector%20art%2C%20premium%20composition&width=1200&height=680&seq=gua-feat-02&orientation=landscape",
  },
  {
    eyebrow: "现象观察 · 社会篇",
    title: "为什么我们一边嫌吵，一边戒不掉热搜",
    excerpt: "热搜背后是注意力经济，也藏着普通人寻找谈资、连接彼此的需求。一次对「吃瓜心理」的温和复盘。",
    readTime: "10 分钟",
    author: "编辑部社会组",
    date: "周三长文",
    image: "https://readdy.ai/api/search-image?query=Editorial%20longform%20feature%20illustration%20of%20floating%20phones%20with%20hashtags%20and%20chat%20bubbles%2C%20warm%20coral%20amber%20and%20cream%20palette%2C%20soft%20linen%20texture%2C%20flat%20stylized%20vector%20art%2C%20premium%20composition&width=1200&height=680&seq=gua-feat-03&orientation=landscape",
  },
];

export const plans: Plan[] = [
  {
    name: "瓜田日报",
    badge: "每日更新",
    tagline: "每天一封，通勤路上把当天热点看完",
    points: ["工作日每日一更，覆盖 6 大频道", "热榜快讯 + 简短点评，三分钟读完", "重要事件第一时间推送提醒", "适合想跟上节奏的轻度吃瓜用户"],
  },
  {
    name: "瓜田周报",
    badge: "最受欢迎",
    tagline: "每周精选一次，深度回顾本周大瓜",
    points: ["每周六精编推送，节奏更轻松", "本周最热 10 瓜完整复盘", "深度专题 + 舆论走向梳理", "适合不想被频繁打扰的用户"],
  },
  {
    name: "电子报刊",
    badge: "深度订阅",
    tagline: "面向资深读者的多平台电子报刊",
    points: ["专题长文 + 数据解读优先送达", "可配置频道与推送时间", "周末特辑与主编手记", "适合喜欢细嚼慢咽的读者"],
  },
];

export const stats = [
  { num: "3200+", label: "累计推送期数" },
  { num: "48 万", label: "累计订阅读者" },
  { num: "6 大", label: "覆盖内容频道" },
  { num: "95%", label: "读者周打开率" },
];

export const testimonials: Testimonial[] = [
  { name: "阿橙", tag: "瓜田日报订户 · 通勤党", text: "每天早高峰在地铁上把日报看完，几分钟就把全网热点补完了，比我自己刷一小时高效多了。" },
  { name: "栗子同学", tag: "瓜田周报订户 · 学生党", text: "周五忙没空刷，周末看周报就像补了个爽剧番外，条理清楚也不水，深度那栏是我最爱。" },
  { name: "拾月", tag: "电子报刊订户 · 内容从业者", text: "做内容这行最怕错过风向，电子报刊的专题和舆情梳理帮了大忙，不少选题就是从里面挖出来的。" },
  { name: "老周", tag: "瓜田日报订户 · 职场人", text: "以前吃饭都在刷热搜，现在交给瓜报就行。信息不掺水、不贩卖焦虑，这点最难得。" },
];

export const faqs: FaqItem[] = [
  {
    q: "瓜田日报和周报有什么区别？",
    a: "日报面向工作日每天推送，覆盖 6 大频道的快讯和热榜，适合想紧跟当天热点、通勤路上快速补课的用户；周报则在每周六把本周最热的大瓜和深度内容做一次精选复盘，节奏更轻松，适合不想被频繁打扰的读者。",
  },
  {
    q: "订阅后多久能收到第一封推送？",
    a: "提交邮箱并确认订阅后，下一期对应周期的推送就会准时送达。日报一般为工作日的早上 8:00 前后发出，周报在周六上午发出；如果是刚刚订阅，第一封通常从下一个完整周期开始计入。",
  },
  {
    q: "邮件订阅是免费的吗？",
    a: "瓜田日报和瓜田周报的基础订阅均可免费使用，你把喜欢的频道配置好即可。电子报刊则面向深度阅读场景，会开放更多专题长文与数据解读内容，具体内容以订阅页说明为准。",
  },
  {
    q: "可以自定义关注哪些频道吗？",
    a: "可以。在订阅设置中你可以勾选内娱、影视综艺、乐坛、海外、体坛、时尚生活等频道，系统会据此为你定制每期的内容优先级，减少无关信息打扰。",
  },
  {
    q: "想退订或修改推送频率怎么办？",
    a: "每封推送末尾都带有退订与设置入口，点击即可一键调整频率或彻底退订，操作即时生效，不会向你发送骚扰邮件。",
  },
  {
    q: "推送内容是否经过核实？",
    a: "瓜报坚持「先核实、再报道」的原则，对来源不明的信源会标注存疑并跟进求证；涉及人物的事件会给出多方信源视角，避免单方面带节奏，这也是我们口碑的立足点。",
  },
];

export const principles = [
  { icon: "ri-checkbox-circle-line", title: "先核实再发声", desc: "每条推送都经过信源交叉验证，存疑信息明确标注，不抢发、不传谣。" },
  { icon: "ri-eye-line", title: "客观多视角", desc: "同一事件给出多方信源与不同立场，帮你看清全貌，而不是替你下结论。" },
  { icon: "ri-user-heart-line", title: "对读者负责", desc: "信息不掺水、不贩卖焦虑，把「读者真正需要知道的」放在第一位。" },
];